module.exports = __webpack_public_path__ + "static/media/play.96dc0e98.svg";